module.exports = __webpack_public_path__ + "img/4.d48a5305.png";